import { render } from "./TheHeaderLogo.vue?vue&type=template&id=0ceebbe7"
import script from "./TheHeaderLogo.vue?vue&type=script&lang=js"
export * from "./TheHeaderLogo.vue?vue&type=script&lang=js"
script.render = render

export default script